import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';

export const ContentContainer = styled(Flex)`
  overflow-y: auto;
`;

export const CouponCancelWrapper = styled(Flex)`
  border-radius: 4px;
  &:hover {
    background-color: ${({ theme }) => theme.colors.cerise_50};
    cursor: pointer;
  }
`;
